import { Controller } from "@hotwired/stimulus"

// Navigates to a date rather than submitting it: the timesheet timeline and the
// missing-employees screen use a date field as a jump-to control, not as form input.
//
// Put the controller on the wrapper and the action on the picker's field:
//
//   data: { action: 'change->date-navigate#go' }
//
// Replaces timeline_datepicker_controller, whose display format was "d.m.y (D)" — the reason
// that field had to stay readonly while every other date field became typeable.
export default class extends Controller {
  static values = {
    url: String,
    param: { type: String, default: "date" },
    frame: String,
    // Turbo visit action for the frame navigation ("advance" promotes the frame's URL to the
    // document URL). Opt-in: only the screens whose full state lives in the link URL want it.
    visitAction: String,
  }

  go(event) {
    const date = event.target.value
    if (!date) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set(this.paramValue, date)

    if (this.hasFrameValue && this.frameValue) {
      const options = { frame: this.frameValue }
      if (this.visitActionValue) options.action = this.visitActionValue
      Turbo.visit(url.toString(), options)
    } else {
      Turbo.visit(url.toString())
    }
  }
}
